<template>
  <div>
    <CRow>
      <CCol sm="6">
        <div class="card-title mb-3">
          {{ $t("role.planning.wh.title") }}
        </div>
      </CCol>
      <CCol sm="6" class="justify-content-end d-flex">
        <div>
          <CButton color="primary" class="mb-3" @click="addWh()">
            <font-awesome-icon icon="plus" class="mr-2" />
            {{ $t("role.planning.wh.addWh") }}
          </CButton>
        </div>
      </CCol>
    </CRow>

    <CRow v-if="whData && whData.length > 0" class="p-3">
      <Header
        :data="[
          $t('models.market_plan.name'),
          $t('models.market_wh.offset'),
          $t('models.family_address.address'),
          $t('models.family_address.city'),
          $t('models.family_address.postal_code'),
          $t('models.family_address.country'),
          $t('models.market_wh.notifyto'),
          $t('models.market_wh.info'),
          'Actions',
        ]"
      />
      <Row
        v-for="(item, index) in whData"
        :key="index"
        :data="[
          { data: item.address.to, type: 'text' },
          { data: item.offset, type: 'text' },
          { data: item.address.address, type: 'text' },
          { data: item.address.city, type: 'text' },
          { data: item.address.postal_code.postal_code, type: 'text' },
          { data: item.address.country, type: 'text' },
          { data: item.notifyto, type: 'text' },
          { data: item.info, type: 'text' },
          { data: '', type: 'actions' },
        ]"
        :border="true"
        :topAligned="true"
      >
        <template #actions>
          <div class="d-flex justify-content-end">
            <CButton
              class="mr-2 mt-2"
              size="sm"
              color="primary"
              @click="editWh(item)"
            >
              <font-awesome-icon icon="edit" />
            </CButton>
            <CButton
              class="mr-2 mt-2"
              size="sm"
              color="primary"
              @click="removeWh(item.id)"
            >
              <font-awesome-icon icon="trash-alt" />
            </CButton>
          </div>
        </template>
      </Row>
    </CRow>

    <WhModal
      :show.sync="modal.show"
      :title="modal.title"
      :values="modal.values"
      :edit-mode="modal.editMode"
      :edit-id="modal.editId"
      @submitted="fetchData"
    />
  </div>
</template>
<script>
import Header from "../../../common/table/Header.vue";
import Row from "../../../common/table/Row.vue";
import { apiDelete, apiGet } from "../../../helpers/apiHelper";
import WhModal from "./WhModal.vue";

let countryElem, stateElem, countryObj, stateObj;
export default {
  components: {
    Header,
    Row,
    WhModal,
  },
  data() {
    return {
      whData: [],
      modal: {
        show: false,
        title: this.$t("models.market_plan.addForm.modalTitle"),
        values: {},
        editMode: false,
        editId: null,
      },
    };
  },

  methods: {
    addWh() {
      this.modal.title = this.$t("role.planning.wh.addWh");
      this.modal.values = {};
      this.modal.editMode = false;
      this.modal.editId = null;
      this.modal.show = true;
    },

    editWh(item) {
      this.modal.title = this.$t("role.planning.wh.editWh");
      this.modal.values = item;
      this.modal.editMode = true;
      this.modal.editId = item.id;
      this.modal.show = true;
    },

    async removeWh(id) {
      const response = await apiDelete("role_market_planningwh", id, [
        this.$store.state.role.id,
      ]);
      if (response && response.status === 204) {
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("role.planning.wh.removedMsg"),
          color: "success",
          autohide: true,
        });
        await this.fetchData();
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error removing warehouse",
          color: "danger",
          autohide: true,
        });
      }
    },

    async fetchData() {
      const response = await apiGet(
        "role_market_planningwh",
        [this.$store.state.role.id],
        null
      );
      if (response && response.status === 200) {
        this.whData = response.data.Items.sort((a, b) => a.id - b.id);
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading planning data",
          color: "danger",
          autohide: true,
        });
      }
    },
  },

  async created() {
    await this.fetchData();
  },
};
</script>
